import * as React from 'react';
import classnames from 'classnames';

import styles from './styles.module.scss';

type HorizontalFormProps = {
  size: 'large' | 'medium' | 'small';
};

const SIZE_TO_CLASSNAME = {
  large: styles.sizeLarge,
  medium: styles.sizeMedium,
  small: styles.sizeSmall,
};

const HorizontalForm: React.FunctionComponent<HorizontalFormProps> = ({
  size = 'large',
  children,
}) => (
  <div
    className={classnames(
      styles.horizontalFormWrapper,
      SIZE_TO_CLASSNAME[size]
    )}
  >
    {children}
  </div>
);

export default HorizontalForm;
